module.exports = __webpack_public_path__ + "img/mzba.431e8d28.png";